module.exports = __webpack_public_path__ + "img/tap2.ed6255f2.svg";